import React from 'react'
import PropTypes from 'prop-types'
import Table from 'components/Table'
import { makeSitesColumns, makeSitesRows } from '../modalTable'
import { SitesTableWrapper } from './style'
import { useNavigate } from 'react-router-dom'
import { buildAboutUrl, buildMonitoringAboutUrl, editOnly } from 'routing/constants'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { Button } from '@mui/material'
import { FormattedMessage } from 'react-intl'

const TABS = {
  ASSESSMENTS: 'assessments',
  BIODIVERSITY: 'biodiversity'
}

const AssessmentModal = ({
  sites,
  biodiversitySites,
  setActiveTab,
  activeTab = TABS.ASSESSMENTS,
  profile,
  setSiteForDeleting,
  setEditOnlySiteToReject
}) => {
  const navigate = useNavigate()
  const columns = makeSitesColumns(activeTab)
  const parentSiteName = sites && sites.length > 0 ? sites[0].name : ''
  const rows =
    activeTab === TABS.ASSESSMENTS
      ? makeSitesRows(sites, {
        activeTab,
        parentSiteName,
        profile,
        navigate,
        setSiteForDeleting,
        setEditOnlySiteToReject
      })
      : makeSitesRows(biodiversitySites, { activeTab })

  const rowOnClick = (siteId, historyId, siteStatusId, monitoringId) => {
    if (activeTab === TABS.BIODIVERSITY) {
      navigate(buildMonitoringAboutUrl(monitoringId, siteId))
      return
    }
    const editOnlySite =
      siteStatusId === SITE_STATUS_EDIT_ONLY_ID ||
      siteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
        ? editOnly
        : null
    navigate(buildAboutUrl(siteId, historyId, editOnlySite))
  }

  return (
    <SitesTableWrapper>
      <div className="tabs-wrapper">
        <Button
          className={`tab ${activeTab === TABS.ASSESSMENTS ? 'active' : ''}`}
          onClick={() => setActiveTab(TABS.ASSESSMENTS)}
        >
          <FormattedMessage id="assessments" />
        </Button>

        <Button
          className={`tab ${activeTab === TABS.BIODIVERSITY ? 'active' : ''}`}
          onClick={() => setActiveTab(TABS.BIODIVERSITY)}
        >
          <FormattedMessage id="biodiversityEvaluations" />
        </Button>
      </div>
      <Table
        columns={columns}
        rows={rows}
        noResultMessage="noReassessmentHistory"
        dataTest="sites-list"
        rowOnClick={rowOnClick}
        overflow={false}
      />
    </SitesTableWrapper>
  )
}

AssessmentModal.propTypes = {
  sites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      createdAt: PropTypes.string,
      SiteStatusId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      historyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      sitehistoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      ProposerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      proposerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      User: PropTypes.shape({
        lastName: PropTypes.string,
        firstName: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        SiteCoProposers: PropTypes.array
      }),
    })
  ).isRequired,
  biodiversitySites: PropTypes.array,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  profile: PropTypes.object,
  setSiteForDeleting: PropTypes.func,
  setEditOnlySiteToReject: PropTypes.func
}

export default AssessmentModal
